(function () {
  initializeUtilsFunctions();
  executeOnce('spa_controller', function () {
    const crm = document.querySelector('.crm');
    if (crm && crm.hasAttribute('data-src') && !crm.hasAttribute('src')) {
      crm.setAttribute('src', crm.getAttribute('data-src'));
    }
  });
})();
